import { combineReducers } from "redux";

import Search from "./Search";
import Order from "./Order";
import OrdersSummaryEmail from "./OrdersSummaryEmail";
import OrderCancel from "./OrderCancel";
import OrderReturn from "./OrderReturn";
import OrderReplace from "./OrderReplace";
import OrderInvoice from "./OrderInvoice";
import Misc from "./Misc";
import EgiftCardsEmail from "./EgiftCardsEmail";

export default combineReducers(
    Object.assign(
        {},
        {},
        {
            Search,
            Order,
            OrdersSummaryEmail,
            OrderCancel,
            OrderReturn,
            OrderReplace,
            OrderInvoice,
            Misc,
            EgiftCardsEmail
        }
    )
);



// WEBPACK FOOTER //
// ./src/_reducers/index.js